import React from 'react';
import { SignIn as SignInComponent } from '@thd-olt-component-react/sign-in';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';

export function SignIn() {
  const customerName = typeof window === 'undefined' ? null : window?.THDCustomer?.default?.username;
  const customerEmail = typeof window === 'undefined' ? null : window?.THDCustomer?.default?.email;
  return (
    <ErrorBoundary name="sign-in">
      <QueryProvider cacheKey="sign-in">
        <div
          id="signIn-php"
          className="sui-h-full"
        >
          <SignInComponent
            customerName={customerName}
            customerEmail={customerEmail}
            schema="pers_signInCard"
          />
        </div>
      </QueryProvider>
    </ErrorBoundary>
  );
}
